export default __webpack_public_path__ + "static/push-2e07fdce932ddddd680fa01432fc8e9e.webp";